import { Box, Divider, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const FooterRoot = styled(Box)(({ theme }) => ({
  padding: theme.spacing(12),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  backgroundColor: '#161A50',
  marginTop: theme.spacing(20),
}));

export const FooterTopRow = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(6),
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    gap: theme.spacing(16),
  },
}));

export const BrandBox = styled(Box)({
  flex: '1 1 auto',
});

export const BrandRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

export const BrandTitle = styled(Typography)(({ theme }) => ({
  color: theme.designTokens.white,
  fontSize: theme.typography.pxToRem(20),
  fontWeight: 600,
}));

export const Description = styled(Typography)(({ theme }) => ({
  color: theme.designTokens.slate[400],
  marginTop: theme.spacing(4),
  maxWidth: theme.spacing(75),
}));

export const LinksColumn = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
}));

export const ColumnHeading = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(14),
  fontWeight: 600,
  color: theme.designTokens.slate[400],
}));

export const FooterLinkText = styled('span')(({ theme }) => ({
  ...theme.typography.body1,
  color: theme.designTokens.slate[200],
  lineHeight: '24px',
  fontWeight: 600,
  display: 'inline',
}));

export const FooterDivider = styled(Divider)(({ theme }) => ({
  borderColor: theme.designTokens.slate[500],
  marginTop: theme.spacing(8),
  [theme.breakpoints.up('md')]: {
    marginTop: theme.spacing(16),
  },
}));

export const BottomRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  marginTop: theme.spacing(8),
  flexDirection: 'column',
  gap: theme.spacing(2),
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    alignItems: 'center',
  },
}));

export const Copyright = styled(Typography)(({ theme }) => ({
  color: theme.designTokens.slate[400],
}));
